import React, { useState, useEffect } from "react";
import ShareModal from "./shareModal";
import "../components/custom.css";

const statesAndDistricts = {
  Andhra_Pradesh: [
    "Anantapur",
    "Chittoor",
    "East Godavari",
    "Guntur",
    "Krishna",
    "Kurnool",
    "Prakasam",
    "Srikakulam",
    "Visakhapatnam",
    "Vizianagaram",
    "West Godavari",
    "YSR Kadapa",
    "Nellore",
    "Alluri Sitharama Raju",
    "Anakapalli",
    "Eluru",
    "Konaseema",
    "Nandyal",
    "Sri Potti Sriramulu Nellore",
    "Parvathipuram Manyam",
    "Sri Sathya Sai",
    "Tirupati",
    "Annamayya",
    "Bapatla",
    "Kakinada",
    "Palnadu",
  ],
  Telangana: [
    "Adilabad",
    "Bhadradri Kothagudem",
    "Hanamkonda",
    "Hyderabad",
    "Jagtial",
    "Jangaon",
    "Jayashankar Bhupalpally",
    "Jogulamba Gadwal",
    "Kamareddy",
    "Karimnagar",
    "Khammam",
    "Kumuram Bheem",
    "Mahabubabad",
    "Mahabubnagar",
    "Mancherial",
    "Medak",
    "Medchal-Malkajgiri",
    "Mulugu",
    "Nagarkurnool",
    "Nalgonda",
    "Narayanpet",
    "Nirmal",
    "Nizamabad",
    "Peddapalli",
    "Rajanna Sircilla",
    "Ranga Reddy",
    "Sangareddy",
    "Siddipet",
    "Suryapet",
    "Vikarabad",
    "Wanaparthy",
    "Warangal",
    "Yadadri Bhuvanagiri",
  ],
};

const LAST_SEARCH_CRITERIA_KEY = "lastUserSearchCriteria";

const CollegeGuideForm = ({
  formData: propFormData,
  onChange: propOnChange,
  onSubmit: propOnSubmit,
}) => {
  const [formData, setFormData] = useState({
    rank: "",
    gender: "Male",
    caste: "oc",
    examType: "ap",
    year: "2023",
    location: "",
  });
  const [rankError, setRankError] = useState("");
  const [isShareTextVisible, setIsShareTextVisible] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const isControlled = !!propFormData;
  const currentFormData = isControlled ? propFormData : formData;
  const currentPageUrl = window.location.href;

  // Effect to show and hide share text
  useEffect(() => {
    // Show text on render
    // setIsShareTextVisible(true);
    const timer1 = setTimeout(() => {
      setIsShareTextVisible(true);
    }, 300);
    // Hide text after 2 seconds
    const timer = setTimeout(() => {
      setIsShareTextVisible(false);
    }, 2500);
    return () => {
      clearTimeout(timer);
      clearTimeout(timer1);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFormData = { ...currentFormData };

    if (name === "examType") {
      newFormData.examType = value;
      newFormData.year =
        value === "ap" || value === "ap_bipc"
          ? "2023"
          : value === "ts_bipc"
          ? "first"
          : "2024_first";
      newFormData.location = "";

      if (propOnChange) {
        propOnChange({
          target: { name: "examType", value: newFormData.examType },
        });
        propOnChange({ target: { name: "year", value: newFormData.year } });
        propOnChange({
          target: { name: "location", value: newFormData.location },
        });
      }
    } else {
      newFormData[name] = value;
      if (propOnChange) {
        propOnChange({ target: { name, value: newFormData[name] } });
      }
    }

    if (name === "rank") {
      const numValue = Number(value);
      if (value === "") setRankError("Rank is required");
      else if (isNaN(numValue)) setRankError("Please enter a valid number");
      else if (numValue < 1) setRankError("Rank must be at least 1");
      else if (numValue > 500000) setRankError("Rank cannot exceed 500,000");
      else setRankError("");
    }

    if (!propOnChange) {
      setFormData(newFormData);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !currentFormData.location &&
      (currentFormData.examType === "ap" ||
        currentFormData.examType === "ap_bipc" ||
        currentFormData.examType === "ts" ||
        currentFormData.examType === "ts_bipc")
    ) {
      alert("Please select a location (district).");
      return;
    }
    if (rankError) {
      alert("Please correct the rank error before submitting.");
      return;
    }

    // Store search criteria only if submission proceeds
    if (propOnSubmit) {
      propOnSubmit(currentFormData);
      const currentCriteriaString = JSON.stringify(currentFormData);
      localStorage.setItem(LAST_SEARCH_CRITERIA_KEY, currentCriteriaString);
    }
  };

  const inputClasses =
    "w-full px-3 py-2.5 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 shadow-sm";

  const hasRequiredFields =
    currentFormData.rank &&
    currentFormData.gender &&
    currentFormData.caste &&
    currentFormData.location &&
    !rankError;

  return (
    <div
      className={
        isControlled
          ? "container mx-auto"
          : "bg-gradient-to-b from-blue-50 to-gray-50 pt-4"
      }
    >
      <div
        className={`${
          isControlled
            ? "bg-white rounded-xl shadow-md border border-gray-200 p-5 form-section"
            : "container mx-auto px-4 "
        }`}
      >
        <div className="max-w-full">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold text-gray-800 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2 text-blue-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                  clipRule="evenodd"
                />
              </svg>
              Student Details
            </h2>

            <div
              className="relative flex flex-col items-end"
              onMouseEnter={() => setIsShareTextVisible(true)}
              onMouseLeave={() => setIsShareTextVisible(false)}
            >
              {/* Share Tooltip */}
              <div
                className={`
              absolute -top-10 right-0 bg-blue-300 text-gray-800 px-4 py-2 rounded-lg shadow-lg 
              text-sm font-medium transition-all duration-300 ease-in-out whitespace-nowrap
              ${
                isShareTextVisible
                  ? "opacity-100 translate-y-0 scale-100"
                  : "opacity-0 translate-y-2 scale-95"
              }
            `}
              >
                Share With Friends
              </div>
              <button
                onClick={() => setIsShareModalOpen(true)}
                className="ml-4 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-3 sm:px-4 rounded-lg flex items-center shadow-sm transition-colors text-sm"
                aria-label="Share this page"
              >
                <svg
                  className="h-4 w-4 sm:h-5 sm:w-5 sm:mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8.684 13.342C8.886 12.938 9 12.482 9 12s-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6.001l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z"
                  ></path>
                </svg>
                <span className="hidden sm:inline">Share</span>
              </button>
            </div>
            {/* {hasRequiredFields && (
              <span className="bg-green-100 text-green-800 text-xs py-1 px-2 rounded-full flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3.5 w-3.5 mr-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                Details Complete
              </span>
            )} */}
          </div>

          <form
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
            onSubmit={handleSubmit}
          >
            <div className="relative group">
              <label className="text-sm font-medium text-gray-700 mb-1 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1 text-blue-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Exam Type<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <select
                  name="examType"
                  value={currentFormData.examType}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 shadow-sm appearance-none bg-white"
                >
                  <option value="ap">AP EAPCET (Engineering)</option>
                  <option value="ap_bipc">AP EAPCET (B.Pharmacy)</option>
                  <option value="ts">TS EAPCET (Engineering)</option>
                  <option value="ts_bipc">TS EAPCET (B.Pharmacy)</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    className="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>

            <div className="relative group">
              <label className="text-sm font-medium text-gray-700 mb-1 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                    clipRule="evenodd"
                  />
                </svg>
                Rank<span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                name="rank"
                value={currentFormData.rank}
                onChange={handleChange}
                max="500000"
                min="1"
                maxLength={6}
                required
                placeholder="Enter your rank"
                className={`${inputClasses} ${
                  rankError
                    ? "border-red-500"
                    : currentFormData.rank
                    ? "border-green-300 bg-green-50"
                    : ""
                } group-hover:border-blue-300`}
              />
              {rankError && (
                <p className="text-red-500 text-sm mt-1">{rankError}</p>
              )}
            </div>

            <div className="relative group">
              <label className="text-sm font-medium text-gray-700 mb-1 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clipRule="evenodd"
                  />
                </svg>
                Gender<span className="text-red-500">*</span>
              </label>
              <div className="flex items-center space-x-4 mt-2 bg-gray-50 p-2.5 rounded-lg border border-gray-200 group-hover:border-blue-300 transition-all">
                <div className="flex items-center">
                  <input
                    type="radio"
                    id="male"
                    name="gender"
                    value="Male"
                    checked={currentFormData.gender === "Male"}
                    onChange={handleChange}
                    required
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                  />
                  <label
                    htmlFor="male"
                    className="ml-2 text-gray-800 text-sm font-medium"
                  >
                    Male
                  </label>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    id="female"
                    name="gender"
                    value="Female"
                    checked={currentFormData.gender === "Female"}
                    onChange={handleChange}
                    required
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                  />
                  <label
                    htmlFor="female"
                    className="ml-2 text-gray-800 text-sm font-medium"
                  >
                    Female
                  </label>
                </div>
              </div>
            </div>

            <div className="relative group">
              <label className="text-sm font-medium text-gray-700 mb-1 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                </svg>
                Category<span className="text-red-500">*</span>
              </label>
              <select
                name="caste"
                value={currentFormData.caste}
                onChange={handleChange}
                required
                className={`${inputClasses} ${
                  currentFormData.caste ? "border-green-300 bg-green-50" : ""
                } appearance-none group-hover:border-blue-300 bg-white pr-8`}
              >
                <option value="" disabled>
                  Select your category
                </option>
                <option value="oc">General</option>
                <option value="ews">EWS</option>
                <option value="bca">BC-A</option>
                <option value="bcb">BC-B</option>
                <option value="bcc">BC-C</option>
                <option value="bcd">BC-D</option>
                <option value="bce">BC-E</option>
                <option value="sc">SC</option>
                <option value="st">ST</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 top-5">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>

            <div className="relative group">
              <label className="text-sm font-medium text-gray-700 mb-1 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1 text-blue-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                Location (District)<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <select
                  name="location"
                  value={currentFormData.location}
                  onChange={handleChange}
                  required
                  className={`${inputClasses} ${
                    currentFormData.location
                      ? "border-green-300 bg-green-50"
                      : ""
                  } appearance-none group-hover:border-blue-300 bg-white pr-8`}
                >
                  <option value="">Select District</option>
                  {(currentFormData.examType === "ap" ||
                    currentFormData.examType === "ap_bipc") &&
                    statesAndDistricts.Andhra_Pradesh.map((district) => (
                      <option key={district} value={district}>
                        {district}
                      </option>
                    ))}
                  {(currentFormData.examType === "ts" ||
                    currentFormData.examType === "ts_bipc") &&
                    statesAndDistricts.Telangana.map((district) => (
                      <option key={district} value={district}>
                        {district}
                      </option>
                    ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 top-5">
                  <svg
                    className="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>

            <div className="relative group flex justify-end items-end lg:col-span-3">
              <button
                type="submit"
                disabled={!hasRequiredFields}
                className={`w-full md:w-auto h-[42px] px-6 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 whitespace-nowrap ${
                  !hasRequiredFields ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                Find Colleges
              </button>
            </div>
          </form>
        </div>
      </div>

      <ShareModal
        open={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        link={currentPageUrl}
      />

    </div>
  );
};

export default CollegeGuideForm;
